export default "/assets/images/mila-feed-05-thumbnail.jpg?7ae29f95acfc6d41bfd76d2bbadd2260";